












































































import { Vue, Component, Prop } from 'vue-property-decorator'

import RoundAvatar from '@/components/RoundAvatar.vue'

import CreditNote from '@/models/credit-note'
import Passenger from '@/models/passenger'
import Payment from '@/models/payment'

import { longDateFormat } from '@/globalFilters'
import MasterPaymentInfoService from '@/services/PaymentInfo/MasterPaymentInfoService'

@Component({
  components: {
    RoundAvatar,
  },
})
export default class CreditNoteList extends Vue {
  @Prop() creditNote!: CreditNote
  @Prop() refunds!: Payment[]
  @Prop() passengerEntities!: { [id: number]: Passenger }

  dateFormat = longDateFormat

  get payments(): Payment[] {
    return this.refunds.map((refund) => {
      let passengerPayer

      if (refund.passengerPayerId) {
        passengerPayer = this.passengerEntities[refund.passengerPayerId]
      }

      return { ...refund, passengerPayer }
    })
  }

  get total(): number {
    return this.refunds.reduce((sum, ps) => (sum += ps.refundedAmountCents), 0)
  }

  refundedPassenger(refund: Payment): Passenger | null {
    return refund.passengerPayerId
      ? this.passengerEntities[refund.passengerPayerId]
      : null
  }

  creditedToName(refund: Payment): string {
    return refund.cardHolder || ''
  }

  getRefundInfo(refund: Payment): string {
    return new MasterPaymentInfoService(refund).call()
  }

  getRefundLastFour(refund: Payment): string {
    switch (refund.lastFour) {
      case 'EFT':
        return 'Bank refund'
      default:
        return refund.lastFour ? `XXXX-XXXX-XXXX-${refund.lastFour}` : ''
    }
  }
}
